const UserRoleEnum = {
  SuperAdmin: 1,
  Admin: 2,
  User: 3,
};

const UserStatusEnum = {
  unblock: 0,
  blocked: 1,
};
class UserEnum {
  static get UserRoleEnum() {
    return UserRoleEnum;
  }

  static get UserStatusEnum() {
    return UserStatusEnum;
  }
}
export default UserEnum;

export const UserClosed = {
  normal: 0,
  closedTime: 1,
  closedTerminal: 2,
};

export const UserAction = {
  VERIFY: "verify",
  BLOCK: "block",
  UNBLOCK: "unblock",

  REOPEN: "reopen",
  DELETE: "delete",
  VERIFY_ACCOUNT: "verifyAccount",
  ADD_BALANCE: "addBalance",
  ADD_RE_BUY_TOKEN: "addReBuyToken",
  ADD_VOUCHER: "addVoucher",

  SET_CLIENT_PROFILE: "setClientProfile",
  UPDATE_AFFILIATE: "affiliateUpdate",
  UPDATE_SUB_AFFILIATE: "subAffiliateUpdate",

  UPDATE_WITHDRAWABLE: "updateWithdrawable",
  UPDATE_NOTES: "updateNotes",
  DELETE_BANK_ACCOUNT: "deleteBankAccount",

  DELETE_CREDIT_CARD: "deleteCreditCard",
  ADD_SERVICE_BALANCE: "transferExternalWallet",
  WITHDRAW_SERVICE_BALANCE: "withdrawExternalWallet",
};

export const UserActionTrackingTypeEnum = {
  Admin: 1,
  User: 3,
};

export const ExportCSVEnum = {
  All: 1,
  Time: 2,
};

export const ADMIN_ACCOUNT =
  process.env.VUE_APP_EXTERNAL_SERVICE_ACC;

export const permissionConfig = {
  betting: {
    title: "Betting Permissions",
    permissions: {
      competition: {
        title: "Competition",
        description: "Manage competitions and tournaments",
      },
      event: {
        title: "Event",
        description: "Create and manage betting events",
      },
      odds: {
        title: "Odds",
        description: "Set and modify betting odds",
      },
    },
  },
  customer: {
    title: "Customer Permissions",
    permissions: {
      customer: {
        title: "Customers",
        description: "View and manage customer accounts",
      },
    },
  },
  marketing: {
    title: "Marketing Permissions",
    permissions: {
      campaign: {
        title: "Campaigns",
        description: "Create and manage marketing campaigns",
      },
      promotion: {
        title: "Promotions",
        description: "Set up promotional offers",
      },
    },
  },
  trading: {
    title: "Trading Permissions",
    permissions: {
      trading: {
        title: "Trading",
        description: "Access trading dashboard and tools",
      },
    },
  },
  analytics: {
    title: "Analytics Permissions",
    permissions: {
      report: {
        title: "Reports",
        description: "Generate and view reports",
      },
    },
  },
  system: {
    title: "System Permissions",
    permissions: {
      setting: {
        title: "Settings",
        description: "System configuration and settings",
      },
      // user: {
      //   title: "Users",
      //   description: "Manage users",
      // },
      role: {
        title: "Users & Roles",
        description: "Manage users and role permissions",
      },
      audit: {
        title: "Audit",
        description: "View audit logs and system activities",
      },
    },
  },
  financials: {
    title: "Financial Permissions",
    permissions: {
      financial: {
        title: "Financials",
        description: "Access financial data and reports",
      },
    },
  },
  technical: {
    title: "Technical Permissions",
    permissions: {
      api: {
        title: "API Access",
        description: "Access to system APIs and endpoints",
      },
      database: {
        title: "Database",
        description: "Direct database access and queries",
      },
      server: {
        title: "Server Admin",
        description: "Server administration and maintenance",
      },
      backup_restore: {
        title: "Backup/Restore",
        description: "System backup and restore operations",
      },
    },
  },
};

export const resources = [
  { key: "competition", name: "COMPETITION" },
  { key: "event", name: "EVENT" },
  { key: "odds", name: "ODDS" },
  { key: "customer", name: "CUSTOMERS" },
  { key: "campaign", name: "CAMPAIGNS" },
  { key: "promotion", name: "PROMOTIONS" },
  { key: "trading", name: "TRADING" },
  { key: "report", name: "REPORTS" },
  { key: "setting", name: "SETTINGS" },
  // { key: "user", name: "USERS" },
  { key: "role", name: "USERS & ROLES" },
  { key: "audit", name: "AUDIT" },
  { key: "financial", name: "FINANCIALS" },
  { key: "api", name: "API ACCESS" },
  { key: "database", name: "DATABASE" },
  { key: "server", name: "SERVER ADMIN" },
  { key: "backup_restore", name: "BACKUP/RESTORE" },
];

export const fieldsCustomerSegment = [
  { label: "Last30Days TotalBets", value: "last30TotalBets" },
  { label: "Last90Days TotalBets", value: "last90TotalBets" },
  { label: "LifeTime TotalBets", value: "lifeTimeTotalBets" },
  { label: "LifeTime TotalMargin", value: "lifeTimeTotalMargin" },
  { label: "Average Bet", value: "averageBet" },
  { label: "Deposit Limit", value: "hasDepositLimit" },
  { label: "Profit", value: "profit" },
  { label: "GGR%", value: "ggr" },
  { label: "Last Active", value: "lastActive" },
  { label: "Client State", value: "state" },
  { label: "Cash Balance", value: "balance" },
  { label: "Tag is", value: "tag" },
  { label: "Profile", value: "profile" },
  { label: "is verified", value: "isVerified" },
  { label: "Registration Date", value: "createdTime" },
  { label: "Age", value: "age" },
  { label: "Country", value: "country" },
  { label: "Deposit Count", value: "depositCount" },
  { label: "Withdrawal Count", value: "withdrawalCount" },
  { label: "Average Bet Size", value: "averageBetSize" },
  { label: "Favorite Sport", value: "favoriteSport" },
  { label: "Risk Score", value: "riskScore" },
  // { label: "Racing MaxBet Limit", value: "racingMaxBetLimit" },
  // { label: "Racing Exposure Limit", value: "racingExposureLimit" },
  // { label: "Racing Daily Loss Limit", value: "racingDailyLossLimit" },
  // { label: "Sport MaxBet Limit", value: "sportMaxBetLimit" },
  // { label: "Sport Exposure Limit", value: "sportExposureLimit" },
  // { label: "sport Daily Loss Limit", value: "sportDailyLossLimit" },
];

export const YesNoOption = [
  { label: "Yes", value: "1" },
  { label: "No", value: "0" },
];
